module.exports = __webpack_public_path__ + "img/logo.1ef51491.png";